import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResultsExperience from './results/ResultsExperience';
import { StepProgress } from './upload/StepProgress';
import { UploadStep } from './upload/UploadStep';
import { RegistrationStep } from './upload/RegistrationStep';
import { ParsingStep } from './upload/ParsingStep';
import { QuestionnaireStep } from './upload/QuestionnaireStep';
import { useUploadFlow } from './upload/useUploadFlow';

const UploadFlow = () => {
  const navigate = useNavigate();
  const {
    step, file, userData, setUserData, questions, answers, setAnswers,
    assessment, loading, error, parseLines,
    onDrop, goBackToUpload, registerAndParse, submitQuestionnaire,
  } = useUploadFlow();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)' }}>
      {step < 5 && (
        <header className="app-header">
          <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              <img src="/axpats-logo.webp" alt="Axpats" style={{ height: '40px' }} />
            </div>
          </div>
        </header>
      )}

      <div style={{ maxWidth: step === 5 ? '100%' : '720px', margin: '0 auto', padding: step === 5 ? '0' : '2rem 1.5rem 4rem' }}>
        {step < 5 && <StepProgress step={step} error={error} />}

        {step === 1 && <UploadStep onDrop={onDrop} />}

        {step === 2 && (
          <RegistrationStep
            fileName={file?.name}
            userData={userData}
            setUserData={setUserData}
            onSubmit={registerAndParse}
            onBack={goBackToUpload}
            loading={loading}
          />
        )}

        {step === 3 && <ParsingStep parseLines={parseLines} />}

        {step === 4 && (
          <QuestionnaireStep
            questions={questions}
            answers={answers}
            setAnswers={setAnswers}
            onSubmit={submitQuestionnaire}
            loading={loading}
          />
        )}

        {step === 5 && assessment && (
          <ResultsExperience assessment={assessment} userData={userData} />
        )}
      </div>
    </div>
  );
};

export default UploadFlow;
